import _ from 'lodash'
import { v4 as uuidv4 } from 'uuid'

import { defaultInstance } from 'services'

import { responseSuccess, responseError } from 'utils/response'

const getStatuses = () => {
  return [
    { label: 'Active', value: true },
    { label: 'Inactive', value: false },
  ]
}

const statuses = getStatuses()

const getStatusByValue = (value) => {
  return _.find(statuses, { value })
}

export const mapFieldGroupAttributeFilter = (item, index) => {
  return {
    index,
    key: uuidv4(),
    id: item?.attribute_group_id,
    name: item?.attribute_group_name,
    description: item?.attribute_group_description,
    order: item?.attribute_group_order,
    isEnabled: item?.is_active,
    status: getStatusByValue(item?.is_active),
  }
}

export const getGroupAttributeFilterListApi = () => {
  const config = {
    method: 'get',
    url: '/api/v1/filters/group_attribute',
  }

  return defaultInstance
    .request(config)
    .then((res) => {
      if (_.size(res.data) >= 0 && _.isArray(res.data)) {
        return responseSuccess({ data: _.map(res.data, mapFieldGroupAttributeFilter) })
      }
      return responseError({ message: 'API something went wrong' })
    })
    .catch((err) => {
      if (err.response) {
        return responseError({
          message: String(err.response.data?.detail || err.response.data?.message),
        })
      } else if (err.request) {
        return responseError({ message: err.message })
      }
      return responseError({ message: err.message })
    })
}
